import { Component, EventEmitter, Input, OnInit, Output, NgModule, Inject, AfterViewInit } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { ApiService } from '@services/api.service';
import { LocalizationService } from '@services/localization.service';

import { UiHelper } from '@helpers/ui.helper';
import { UserHelper } from '@helpers/user.helper';
import { TranslatePipe } from '@pipes/translate.pipe';
import { Router } from '@angular/router';
import { environment } from '@environments/environment';

declare const grMobileLoader: any;
declare const grDesktopLoader: any;

@Component({
  selector: 'casino-component',
  templateUrl: '../sharedTemplates/virtualgameGR.component.html',
})
export class VirtualgameGRComponent implements AfterViewInit {
  casinoList = [];
  gameTypes = [];
  _URLFRAME;
  _style = {
    iframeStyle: {
      width: this._UiHelper.windowsWidth + 'px',
      height: this._UiHelper.windowsHeight - 35 + 'px',
    },
  };

  //todo this needs to be configured

  constructor(
    private _ApiService: ApiService,
    public _UiHelper: UiHelper,
    public _UserHelper: UserHelper,
    private _LocalizationService: LocalizationService,
    private _router: Router
  ) {}

  ngAfterViewInit() {
    this._ApiService.getLinkVirtualGoldenRace().then(res => {
      if (environment.mobile) {
        const loader = grMobileLoader({
          onlineHash: res,
        });
      } else {
        const loader = grDesktopLoader({
          onlineHash: res,
        });
      }

      //this._URLFRAME = res;
      ////console.log(res);
    });
  }
}
